import { TariffCategory } from '../../shared/models/types'
import { TariffDetailsDto } from '../../tariffs/api/dto/single-tariff.dto'
import { MOCK_CURRENCY, MOCK_ENERGY_TYPE } from './mock-properties'

export const MOCK_DYNAMIC_TARIFF: TariffDetailsDto = {
  tariffCategory: TariffCategory.dynamicTariff,
  tariffName: 'Dynamic tariff',
  tariffElement: [
    /** Midnight to early morning — very cheap */
    {
      start_date_time: '2025-06-22T00:00',
      end_date_time: '2025-06-22T00:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.16,
    },
    {
      start_date_time: '2025-06-22T01:00',
      end_date_time: '2025-06-22T01:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.15,
    },
    {
      start_date_time: '2025-06-22T02:00',
      end_date_time: '2025-06-22T02:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.14,
    },
    {
      start_date_time: '2025-06-22T03:00',
      end_date_time: '2025-06-22T03:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.14,
    },
    {
      start_date_time: '2025-06-22T04:00',
      end_date_time: '2025-06-22T04:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.15,
    },
    {
      start_date_time: '2025-06-22T05:00',
      end_date_time: '2025-06-22T05:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.18,
    },

    /** Morning peak */
    {
      start_date_time: '2025-06-22T06:00',
      end_date_time: '2025-06-22T06:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.36,
    },
    {
      start_date_time: '2025-06-22T07:00',
      end_date_time: '2025-06-22T07:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.42,
    },
    {
      start_date_time: '2025-06-22T08:00',
      end_date_time: '2025-06-22T08:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.4,
    },
    {
      start_date_time: '2025-06-22T09:00',
      end_date_time: '2025-06-22T09:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.38,
    },

    /** Midday — moderate to cheap */
    {
      start_date_time: '2025-06-22T10:00',
      end_date_time: '2025-06-22T10:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.3,
    },
    {
      start_date_time: '2025-06-22T11:00',
      end_date_time: '2025-06-22T11:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.27,
    },
    {
      start_date_time: '2025-06-22T12:00',
      end_date_time: '2025-06-22T12:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.22,
    },
    {
      start_date_time: '2025-06-22T13:00',
      end_date_time: '2025-06-22T13:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.21,
    },
    {
      start_date_time: '2025-06-22T14:00',
      end_date_time: '2025-06-22T14:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.22,
    },
    {
      start_date_time: '2025-06-22T15:00',
      end_date_time: '2025-06-22T15:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.24,
    },

    /** Evening peak — highest */
    {
      start_date_time: '2025-06-22T16:00',
      end_date_time: '2025-06-22T16:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.32,
    },
    {
      start_date_time: '2025-06-22T17:00',
      end_date_time: '2025-06-22T17:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.46,
    },
    {
      start_date_time: '2025-06-22T18:00',
      end_date_time: '2025-06-22T18:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.48,
    },
    {
      start_date_time: '2025-06-22T19:00',
      end_date_time: '2025-06-22T19:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.48,
    },
    {
      start_date_time: '2025-06-22T20:00',
      end_date_time: '2025-06-22T20:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.44,
    },
    {
      start_date_time: '2025-06-22T21:00',
      end_date_time: '2025-06-22T21:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.36,
    },

    /** Night — dropping back down */
    {
      start_date_time: '2025-06-22T22:00',
      end_date_time: '2025-06-22T22:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.26,
    },
    {
      start_date_time: '2025-06-22T23:00',
      end_date_time: '2025-06-22T23:59',
      type: MOCK_ENERGY_TYPE,
      price: 0.2,
    },
  ],
  solarPrice: null,
  dischargePrice: 2,
  lastUpdated: '2025-06-22T07:06:01Z',
  start_date_time: null,
  end_date_time: null,
  currencyCode: MOCK_CURRENCY,
  vatRate: 19,
}
